// extracted by mini-css-extract-plugin
export default {"wrap":"SortSelect_wrap__hsudP","label":"SortSelect_label__YuPZG","select":"SortSelect_select__kpioK"};